import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StaticWhoAreWeComponent } from './components/static-who-are-we/static-who-are-we.component';

@NgModule({
  declarations: [StaticWhoAreWeComponent],
  imports: [
    CommonModule
  ],
  exports: [
    StaticWhoAreWeComponent
  ]
})
export class SipStaticWhoAreWeModule { }
